import { useContext } from "react";
import { Context } from "../context";
import { useParams } from "react-router-dom";
import { Card } from "antd";
import he from '../../node_modules/axe-core/locales/he.json';
import { LayoutGrid } from './LayoutGrid';
import { ProjectsGrid } from "./ProjectsGrid";

export function Project(props) {

  const { alumni, project } = useParams();
  const alumniHandle = alumni.replace('@', '');

  const context = useContext(Context);
  const alumniData = context.x.getAlumniByHandle(alumniHandle);

  const projectData = context.x.getProjectById(project);

  return (
    <>
      {projectData && alumniData && <>
        <Card
          cover={<div style={{
            height: '16em',
            backgroundImage: `url(${projectData.coverImage})`,
            backgroundSize: 'cover',
            backgroundPosition: '0 0',
            backgroundColor: '#2e2e2e',
            height: '56em',
          }} />}
        >
          <h1>{projectData.name}</h1>
        </Card>
        {/* {projectData && <ProjectsGrid data={projectData} />} */}

      </>}
    </>
  )
}
